angular.module('unergie.main')
.directive('salesTunnelNominal', ($q, AuthService, MetaWatcher, BoFeaturesService, CommonRegex, DataAccessSearch, DataAccess, ErrorCatcher, DraftsBasic, DataAccessOffers) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        user: '=',
        checks: '=',
        draftServices: '=',
        disableContractEdition: '=',
        draftState: '=',
    },
    templateUrl: '/states/salesTunnelV2/component/salesTunnelNominal.html',
    link($scope) {
        $scope.showTools = !BoFeaturesService.get('isEnvProd')
        $scope.showSalesTunnelSponsor = BoFeaturesService.isFeatureOn('showSalesTunnelSponsor')
        $scope.showSalesTunnelPromo = BoFeaturesService.getModuleFeatures('canCodePromo').split(',').includes(AuthService.getOrg())
        $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
        $scope.saveUser = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_USER')
        $scope.saveDraftState = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT_STATE')

        // FORM
        $scope.nameRegex = CommonRegex.fullname
        $scope.phoneRegex = CommonRegex.phone.mobiles
        $scope.form = {}

        // VALIDATORS
        const initComponentValidator = () =>
            MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                isCivDefined(store) {
                    return !_.isEmpty(store.draft.civ)
                },
                isGivennameDefined(store) {
                    return !_.isEmpty(store.draft.givenname)
                },
                isSnDefined(store) {
                    return !_.isEmpty(store.draft.sn)
                },
                isSecondNameWellDefined(store) {
                    const allFieldsDefined = [!_.isEmpty(store.draft.civ2), !_.isEmpty(store.draft.sn2), !_.isEmpty(store.draft.givenname2)]
                    return _.every(allFieldsDefined, (val) => val === false) || _.every(allFieldsDefined, (val) => val === true)
                },
                isMailDefined(store) {
                    return !_.isEmpty(store.draft.mail)
                },
                isPhoneDefined(store) {
                    return !_.isEmpty(store.draft.phone) && !!$scope.form.phone
                },
                isBirthDateDefined(store) {
                    return !_.isEmpty(store.draft.birth_date)
                },
                isAcceptContactsDefined(store) {
                    return _.isBoolean(store.draft.accept_contacts)
                },
                isIBANValid(store) {
                    return store.draft.iban === null || IBAN.isValid(store.draft.iban)
                },
                isPromoCodeValid(store) {
                    return store.draft.id_ref_promo === null || $scope.promoValid
                },
                isSponsorCodeValid(store) {
                    return store.draft.sponsor_id === null || $scope.sponsorValid
                },
            })

        $scope.saveNotEmptyOnDraft = function (payload) {
            if (_.every(payload, (v) => !_.isEmpty(v))) {
                return $scope.saveDraft(payload)
            }
        }

        // CIV
        $scope.onUserNominalChanged = function (newNominal) {
            $scope.saveDraft(newNominal)
            DataAccessSearch({ limit: 1 }).search({ resource: 'accounts', mail: $scope.draft.mail.toLowerCase() }).$promise
            .then((users) => $scope.saveUser(users[0])).catch(ErrorCatcher)
        }

        $scope.onUserEmailChanged = function (mail) {
            DataAccessSearch({ limit: 1 }).search({ resource: 'accounts', mail }).$promise
            .then((users) => {
                $scope.saveUser(users[0])
                if ($scope.checks.mailSent) {
                    $scope.draftServices.shootDraft({ mail }, $scope.draft.bulk_purchase ? 'MAIL' : null)
                } else {
                    $scope.saveDraft({ mail })
                }
            }).catch(ErrorCatcher)
        }

        // PHONE
        const formatPhone = function (phone) {
            if (phone && (phone.indexOf('+33') < 0) && (phone.length === 10) && ((phone.indexOf('06') === 0) || (phone.indexOf('07') === 0))) {
                return `+33${phone.slice(1)}`
            }
            return phone
        }

        $scope.savePhone = function (phone) {
            if ($scope.phoneRegex.test(phone)) {
                return $scope.saveDraft({ phone: formatPhone(phone) })
            }
            // force la revalidation pour empécher l'envoi
            MetaWatcher.notif('SALES_TUNNEL.REVALIDATE')
        }

        $scope.onUserPhoneChanged = function (phone) {
            $scope.savePhone(phone)
            DataAccessSearch({ limit: 1 }).search({ resource: 'accounts', mail: $scope.draft.mail.toLowerCase() }).$promise
            .then((users) => $scope.saveUser(users[0])).catch(ErrorCatcher)
        }

        // BIRTH_DATE
        $scope.birthDateValid = (birth_date) => birth_date && moment(birth_date, 'DDMMYYYY').isValid()

        $scope.saveBirthDate = function (birth_date) {
            if ($scope.birthDateValid(birth_date)) {
                return $scope.saveDraft({ birth_date: moment(birth_date, 'DDMMYYYY').format('YYYY-MM-DD') })
            }
        }

        // IBAN
        const listIBAN = [
            'FR7616348000019610406019562',
            'FR7616348000018261323638902',
            'FR7616348000015326593444864',
            'FR7616348000013362218904333',
            'FR7616348000015768307543482',
            'FR7616348000012402275913803',
            'FR7616348000019714043884665',
            'FR7616348000016688736987462',
            'FR7616348000017981955439104',
            'FR7616348000019809488163842',
        ]
        $scope.setIBAN = function () {
            $scope.form.iban = listIBAN[Math.trunc(Math.random() * listIBAN.length)]
            $scope.saveDraft({ iban: $scope.form.iban })
        }

        $scope.saveIBAN = function (iban) {
            if (_.isEmpty(iban)) {
                $scope.form.maskedIban = null
            }
            $scope.modifyingIban = !!$scope.form.maskedIban && !!iban
            $scope.editableIban = !$scope.form.maskedIban || (!!iban && !_.isEmpty(iban))
            $scope.draftState.usingMandateIban = $scope.form.maskedIban && (_.isEmpty($scope.draft.iban) || !$scope.draft.iban)
            $scope.saveDraft({ iban: _.isEmpty(iban) ? null : iban })
        }

        // Edit IBAN
        $scope.chgIBANFields = {
            iban: {
                required: true,
                label: 'IBAN',
                type: 'iban',
            },
            label: {
                label: (payload) => {
                    if (payload.maskedIban) {
                        return `<br><span class="fa fa-warning"></span>&nbsp;Attention :<br>L'IBAN est appliqué sur l'ensemble des contrats du client`
                    }
                },
                type: 'label',
            },
        }
        $scope.chgIBANPayload = { iban: $scope.draft.iban, maskedIban: $scope.form.maskedIban }
        $scope.initChangeIBAN = () => {
            $scope.chgIBANPayload = { iban: $scope.draft.iban, maskedIban: $scope.form.maskedIban }
            $scope.modifyingIban = $scope.form.maskedIban && $scope.draft.iban
            $scope.editableIban = !$scope.form.maskedIban || ($scope.draft.iban && !_.isEmpty($scope.draft.iban))
            $scope.draftState.usingMandateIban = $scope.form.maskedIban && (_.isEmpty($scope.draft.iban) || !$scope.draft.iban)
        }
        $scope.changeIBAN = () => {
            $scope.saveIBAN($scope.chgIBANPayload.iban)
        }

        // SECOND PERSON
        $scope.isSecondPersonFormVisible = false
        $scope.secondPersonCiv = [
            { label: '', value: null },
            { label: 'M.', value: 'M.' },
            { label: 'Mme', value: 'Mme' },
        ]
        $scope.isSecondPersonRequired = () => {
            const isCiv2Defined = !_.isEmpty($scope.form.civ2)
            const isSn2Defined = !_.isEmpty($scope.form.sn2)
            const isGivenname2Defined = !_.isEmpty($scope.form.givenname2)
            return isCiv2Defined || isSn2Defined || isGivenname2Defined
        }
        $scope.saveGivenname2 = (givenname2) => {
            $scope.saveDraft({ givenname2: _.isEmpty(givenname2) ? null : givenname2 })
        }
        $scope.saveSn2 = (sn2) => {
            $scope.saveDraft({ sn2: _.isEmpty(sn2) ? null : sn2 })
        }
        $scope.toggleSecondPersonForm = () => {
            $scope.isSecondPersonFormVisible = !$scope.isSecondPersonFormVisible
            if ($scope.isSecondPersonFormVisible === false) {
                $scope.saveDraft({ civ2: null, sn2: null, givenname2: null })
            }
        }
        const initSecondPersonForm = () => {
            $scope.isSecondPersonFormVisible = $scope.isSecondPersonRequired()
        }

        const updateOnDraft = (draft) => {
            const birth_date_moment = moment(_.get(draft, 'birth_date'))
            $scope.form = {
                civ: _.get(draft, 'civ'),
                givenname: _.get(draft, 'givenname'),
                sn: _.get(draft, 'sn'),
                civ2: _.get(draft, 'civ2'),
                givenname2: _.get(draft, 'givenname2'),
                sn2: _.get(draft, 'sn2'),
                mail: _.get(draft, 'mail'),
                phone: _.get(draft, 'phone'),
                birth_date: birth_date_moment.isValid() ? birth_date_moment.format('DDMMYYYY') : null,
                accept_contacts: _.get(draft, 'accept_contacts'),
                iban: _.get(draft, 'iban', ''),
                sponsor_id: _.get(draft, 'sponsor_id', null),
                id_ref_promo: _.get(draft, 'id_ref_promo', null),
                maskedIban: _.get(draft, 'maskedIban', '') || $scope.form.maskedIban,
            }
            $scope.modifyingIban = !!$scope.form.maskedIban && !!$scope.form.iban
            $scope.editableIban = !$scope.form.maskedIban || (!!$scope.form.iban && !_.isEmpty($scope.form.iban))
            $scope.draftState.usingMandateIban = $scope.form.maskedIban && (_.isEmpty($scope.draft.iban) || !$scope.draft.iban)
        }

        $scope.checkSponsorId = () => {
            if ($scope.form.sponsor_id && $scope.form.sponsor_id.length !== 9) {
                $scope.sponsorValid = false
                return
            }
            $scope.sponsorCheckError = null
            if (!$scope.form.sponsor_id && $scope.sponsor) {
                $scope.checkingSponsor = true
                return DataAccess.removeSponsorOnDraft({ id_draft: $scope.draft.id }).$promise
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.checkingSponsor = false
                })
            }
            if ($scope.form.sponsor_id) {
                $scope.checkingSponsor = true
                $scope.sponsor = null
                return DataAccess.checkSponsorOnDraft({ id_draft: $scope.draft.id, sponsor_id: $scope.form.sponsor_id }).$promise.then((result) => {
                    $scope.sponsor = result.sponsor
                    $scope.sponsorValid = true
                })
                .catch((error) => {
                    $scope.sponsorCheckError = error.data.message
                })
                .finally(() => {
                    $scope.checkingSponsor = false
                })
            }
        }

        $scope.checkPromoCode = () => {
            if ($scope.form.id_ref_promo && $scope.form.id_ref_promo.length < 4) {
                $scope.promoValid = false
                return
            }
            $scope.promoCheckError = null
            if (!$scope.form.id_ref_promo && $scope.promoCode) {
                $scope.checkingPromo = true
                return DraftsBasic.removePromoOnDraft({ id_draft_basic: $scope.draft.id }).$promise
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.checkingPromo = false
                })
            }
            if ($scope.form.id_ref_promo) {
                $scope.checkingPromo = true
                $scope.promoCode = null
                return DraftsBasic.checkPromoOnDraft({ id_draft_basic: $scope.draft.id, id_ref_promo: $scope.form.id_ref_promo }).$promise.then((result) => {
                    $scope.promoCode = result
                    $scope.promoValid = true
                })
                .catch((error) => {
                    $scope.promoCheckError = error.data.message
                })
                .finally(() => {
                    $scope.checkingPromo = false
                })
            }
        }

        const initData = () => {
            // PROVIDER OFFER
            DataAccessOffers.getOffers().$promise.then((offersResult) => {
                $scope.offers = {}
                offersResult.forEach((item) => {
                    $scope.offers[item.id] = item
                })
            }).catch(ErrorCatcher)
        }

        const activate = () => {
            initComponentValidator()
            initData()
            updateOnDraft($scope.draft)
            initSecondPersonForm()
            $scope.checkSponsorId()
            $scope.checkPromoCode()
            $scope.$watch('draft', updateOnDraft)
        }
        activate()
    },
}))
